import React from "react";
import { Link } from "react-router-dom";
import AnchorLink from "react-anchor-link-smooth-scroll";
import Accordion from "./Accordion";
import TeamMember from "./TeamMember";
import GoogleMaps from "./Map";
import { coreValues, ourCapabilities, team } from "../data";

class AboutUs extends React.Component {
  constructor() {
    super();

    this.state = {
      isTop: true,
      modalIsOpen: false
    };
  }

  componentDidMount() {
    document.addEventListener("scroll", () => {
      const isTop = window.scrollY < 100;

      if (isTop !== this.state.isTop && window.innerWidth > 767) {
        this.setState({ isTop });
      }
    });
  }

  render() {
    return (
      <div className="subpage">
        <div className="home-link">
          <Link to="/">
            <span className="glyphicon glyphicon-arrow-left" />
          </Link>
        </div>
        <header
          className="bs-docs-nav navbar navbar-fixed-top header-inverse about-us-header"
          id="top"
          style={{
            backgroundColor: this.state.isTop ? "" : "black"
          }}
        >
          <div className="container">
            <div className="navbar-header">
              <button
                aria-controls="bs-navbar"
                aria-expanded="false"
                className="collapsed navbar-toggle"
                data-target="#bs-navbar"
                data-toggle="collapse"
                type="button"
              >
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar" />
                <span className="icon-bar" />
                <span className="icon-bar" />
              </button>
            </div>
            <nav className="collapse navbar-collapse" id="bs-navbar">
              <ul className="nav navbar-nav navbar-right">
                <li>
                  <AnchorLink href="#who-we-are">Who We Are</AnchorLink>
                </li>
                <li>
                  <AnchorLink href="#core-values">Core Values</AnchorLink>
                </li>
                <li>
                  <AnchorLink href="#our-capabilities">
                    Our Capabilities
                  </AnchorLink>
                </li>
                <li>
                  <AnchorLink href="#executive-team">Executive Team</AnchorLink>
                </li>
                <li>
                  <AnchorLink id="contact-link" href="#contact-us">
                    Contact Us
                  </AnchorLink>
                </li>
              </ul>
            </nav>
          </div>
        </header>
        <div id="div_wrapper">
          <div id="bg_overlay" />
          <div className="video-container">
            <img
              className="video_poster"
              src={`${process.env.PUBLIC_URL}/images/nycbg.jpg`}
            />
          </div>
          <div style={{ marginTop: "150px" }}>
            <div className="container">
              <div className="row">
                <div className="col-sm-12">
                  <section id="who-we-are">
                    <div className="row">
                      <div className="col-sm-10 col-sm-offset-1">
                        <h2>Who We Are</h2>
                        <p>
                          Thelius is a privately-held real estate company that
                          specializes in unlocking value in underutilized real
                          estate. We focus on relationship-driven opportunities
                          where we can improve cash flow and asset value by
                          investing capital, providing strategic advice,
                          repositioning existing buildings, or developing
                          underutilized land. We operate in markets where we
                          have deep roots and are are able to leverage our
                          extensive network to generate off-market deal flow. We
                          have a proven track record of generating exceptional
                          results for our clients, investors, and partners, with
                          whom we maintain trusted, long-term relationships. Our
                          executive team brings more than three decades of work
                          experience at top-tier private equity, asset
                          management, and development companies.
                        </p>
                        <p>
                          Thelius was founded in 2015 and has since completed
                          over $200MM in value-add transactions. We are
                          currently repositioning 1.5MM SF of commercial real
                          estate assets in Manhattan as well as the New York
                          Tri-state area.
                        </p>
                      </div>
                    </div>
                  </section>
                  <section id="core-values">
                    <div className="row">
                      <div className="col-sm-10 col-sm-offset-1">
                        <h2>Core Values</h2>
                        <p>
                          Our core values define us and our work. We incorporate
                          these values in our day-to-day to differentiate our
                          brand and achieve the best results.
                        </p>
                        <Accordion data={coreValues} />
                      </div>
                    </div>
                  </section>
                  <section id="our-capabilities">
                    <div className="row">
                      <div className="col-sm-10 col-sm-offset-1">
                        <h2>Our Capabilities</h2>
                        <p>
                          Thelius is a fully-integrated real estate investment
                          management company. We have in-house capabilities to
                          plan and execute all phases of a complex real estate
                          investment, including a ground-up development. We are
                          uniquely positioned to deliver capital solutions to
                          nonprofit institutions to support their missions,
                          while providing attractive risk-adjusted investment
                          opportunities for our investors.
                        </p>
                        <Accordion data={ourCapabilities} />
                      </div>
                    </div>
                  </section>
                  <section id="executive-team">
                    <div className="row">
                      <div className="col-sm-10 col-sm-offset-1">
                        <h2>Executive Team</h2>
                        <p>
                          Our executive team brings over three decades of
                          experience working for top-tier private equity, asset
                          management, and development companies. We have a
                          proven track record of generating exceptional results
                          to our clients, investors, and partners, with whom we
                          have maintain trusted, long-term relationships. Our
                          executive team is supported by a team of investment
                          associates, asset managers and project managers.
                        </p>
                        <div className="team-grid">
                          <div className="row">
                            {team.map(member => (
                              <TeamMember key={member.name} member={member} />
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                  <section id="contact-us">
                    <div className="row">
                      <div className="col-sm-10 col-sm-offset-1">
                        <h2>Contact Us</h2>
                        <div className="address">
                          <p>Thelius Capital Partners LLC</p>
                          <p>590 Madison Ave, 22nd Floor</p>
                          <p>New York, NY 10022</p>
                          <p>(646) 665-7748</p>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div style={{ width: "100%" }}>
                              <div
                                id="map"
                                style={{
                                  width: "100%",
                                  height: "400px",
                                  position: "relative",
                                  overflow: "hidden"
                                }}
                              >
                                <GoogleMaps />
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            {/* Begin MailChimp Signup Form */}
                            <div id="mc_embed_signup">
                              <form
                                action="//theliuscapital.us15.list-manage.com/subscribe/post?u=07e75fc0f452115d69b735334&id=e01cae270a"
                                className="validate contact-us-form"
                                id="mc-embedded-subscribe-form"
                                method="post"
                                name="mc-embedded-subscribe-form"
                                noValidate
                                target="_blank"
                              >
                                <div id="mc_embed_signup_scroll">
                                  <div className="row">
                                    <div className="col-sm-6">
                                      <div className="form-group">
                                        <div className="mc-field-group">
                                          <input
                                            className="form-control"
                                            id="first_name_input"
                                            name="FNAME"
                                            placeholder="First Name"
                                            type="text"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-sm-6">
                                      <div className="form-group">
                                        <div className="mc-field-group">
                                          <input
                                            className="form-control"
                                            id="mce-LNAME"
                                            name="LNAME"
                                            placeholder="Last Name"
                                            type="text"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-sm-6">
                                      <div className="form-group">
                                        <div className="mc-field-group">
                                          <input
                                            className="email form-control required"
                                            id="mce-EMAIL"
                                            name="EMAIL"
                                            placeholder="Email"
                                            type="email"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-sm-6">
                                      <div className="form-group">
                                        <div className="mc-field-group size1of2">
                                          <input
                                            className="form-control"
                                            id="mce-MMERGE4"
                                            name="MMERGE4"
                                            placeholder="Phone Number"
                                            type="text"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="clear" id="mce-responses">
                                    <div
                                      className="response"
                                      id="mce-error-response"
                                      style={{ display: "none" }}
                                    />
                                    <div
                                      className="response"
                                      id="mce-success-response"
                                      style={{ display: "none" }}
                                    />
                                  </div>
                                  {/* real people should not fill this in and expect good things - do not remove this or risk form bot signups */}
                                  <div
                                    aria-hidden="true"
                                    style={{
                                      position: "absolute",
                                      left: "-5000px"
                                    }}
                                  >
                                    <input
                                      name="b_07e75fc0f452115d69b735334_e01cae270a"
                                      tabIndex={-1}
                                      type="text"
                                    />
                                  </div>
                                  <div className="clear">
                                    <input
                                      className="btn btn-block btn-info button"
                                      id="mc-embedded-subscribe"
                                      name="subscribe"
                                      type="submit"
                                      defaultValue="Request Access"
                                    />
                                  </div>
                                </div>
                              </form>
                            </div>
                            {/* End mc_embed_signup */}
                            <div className="tiny">
                              Please complete the above form to request access
                              to our pipeline or qualify as an investor. Thelius
                              is currently accepting new investors on a select
                              basis.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AboutUs;
